<template>
    <v-sheet color="white"
             elevation="5"
             rounded
             class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
        <v-dialog v-model="showReportDialog">
            <report-viewer v-if="showReportDialog"
                           :reportName="Report_Name"
                           :dataUrl="Report_URL"
                           ref="reportViewer" />
        </v-dialog>
        <div class="profile-content">
            <v-row class="ma-0 mb-3">
                <h1 class="mb-4">{{personInfo.name}}</h1>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="personId" :disabled="!this.personInfo.isActiveMember" v-on:click="showPrintMembershipCardDialog()">Print Membership Card</v-btn>&nbsp;
                <v-btn color="primary"  v-if="personId" v-on:click="showPrintLabelDialog()">Print Label</v-btn>
            </v-row>
            <div v-if="personId">
                <v-tabs v-model="tab">
                    <v-tab key="person">
                        Person
                    </v-tab>
                    <v-tab key="member" v-if="this.personInfo.isMember">
                        <span v-if="!this.personInfo.memberInfo.memberId">Create Member</span>
                        <span v-else>Member</span>
                    </v-tab>
                    <v-tab key="judge" v-if="this.personInfo.isJudge">
                        <span v-if="!this.personInfo.judgeId">Create Judge</span>
                        <span v-else>Judge</span>
                    </v-tab>
                    <v-tab key="junior" v-if="this.personInfo.isJuniorHandler">
                        <span v-if="!this.personInfo.juniorHandlerId">Create Junior Handler</span>
                        <span v-else>Junior Handler</span>
                    </v-tab>
                    <v-tab key="portal">
                        Portal User
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item key="person">
                        <general-person-details :personId="personId" />
                    </v-tab-item>
                    <v-tab-item key="member" v-if="this.personInfo.isMember">
                        <member-details :personId="personId" />
                    </v-tab-item>
                    <v-tab-item key="judge" v-if="this.personInfo.isJudge">
                        <judge-details :personId="personId" />
                    </v-tab-item>
                    <v-tab-item key="junior" v-if="this.personInfo.isJuniorHandler">
                        <junior-handler-details :personId="personId" />
                    </v-tab-item>
                    <v-tab-item key="portal">
                        <portal-user-details :personId="personId" />
                    </v-tab-item>
                </v-tabs-items>
            </div>
            <div v-else>
                <v-tabs v-model="tab">
                    <v-tab key="person">
                        Person
                    </v-tab>
                    
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item key="person">
                        <general-person-details :personId="personId" />
                    </v-tab-item>
                    
                </v-tabs-items>
            </div>
          
        </div>
    </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import GeneralPersonDetails from "@/components/Admin/Details/GeneralPersonDetails.vue";
import MemberDetails from "@/components/Admin/Details/MemberDetails.vue";
import JudgeDetails from "@/components/Admin/Details/JudgeDetails.vue";
import JuniorHandlerDetails from "@/components/Admin/Details/JuniorHandlerDetails.vue";
import PortalUserDetails from "@/components/Admin/Details/PortalUserDetails.vue";
import ReportViewer from '@/components/Admin/Reports/ReportViewer.vue';

import peopleService from "@/services/admin/peopleService";

import { AdminPersonInfo } from '@/types/admin/Person';

export default Vue.extend({
    components: { GeneralPersonDetails, JudgeDetails, JuniorHandlerDetails, PortalUserDetails, ReportViewer, MemberDetails, },
    name: "PersonDetails",
    props: {
        personId: { type: Number },
    },
    data: function () {
        return {
            personInfo: {} as AdminPersonInfo,
            tab: null,
            Report_Name: '',
            Report_URL: '',
            showReportDialog: false,
        };
    },
    created: function () {
        if (this.personId) {
            peopleService
                .getPersonById(this.personId)
                .then((res) => {
                    this.personInfo = res;
                })
                .catch(this.$handleError);
        }
    },
    watch: {
        personId: function (newVal: String) {
            peopleService
                .getPersonById(this.personId)
                .then((res) => {
                    this.personInfo = res;
                })
                .catch(this.$handleError);
        },
    },
    methods: {
        showPrintMembershipCardDialog: function () {
            this.Report_Name = "Asca.Api.Reports.rpt1220_Person_Membership_Card.rdlx";
            this.Report_URL = `/reports/membershipcard/${this.personInfo.personId}`;
            this.showReportDialog = true;
        },
        showPrintLabelDialog: function () {
            this.Report_Name = "Asca.Api.Reports.rpt1210_Person_Label.rdlx";
            this.Report_URL = `/Admin/reports/people/${this.personInfo.personId}/contact`;
            this.showReportDialog = true;

        }
    }
});
</script>
